import {
  INVOICE_DETAIL,
  INVOICE_DETAIL_SUCCESS,
  INVOICE_DETAIL_ERROR,
  INVOICE_SELECT,
  INVOICE_SELECT_SUCCESS,
  INVOICE_SELECT_ERROR,
  INVOICE_UPDATE,
  INVOICE_UPDATE_SUCCESS,
  INVOICE_UPDATE_ERROR,
} from "./actionTypes"

export const invoiceDetail = data => ({
  type: INVOICE_DETAIL,
  payload: data
});

export const invoiceDetailSuccess = data => ({
  type: INVOICE_DETAIL_SUCCESS,
  payload: {data}
});

export const invoiceDetailError = error => ({
  type: INVOICE_DETAIL_ERROR,
  payload: error,
});

export const invoiceSelect = data => ({
  type: INVOICE_SELECT,
  payload: data
});

export const invoiceSelectSuccess = data => ({
  type: INVOICE_SELECT_SUCCESS,
  payload: {data}
});

export const invoiceSelectError = error => ({
  type: INVOICE_SELECT_ERROR,
  payload: error,
});

export const invoiceUpdate = data => ({
  type: INVOICE_UPDATE,
  payload: data
});

export const invoiceUpdateSuccess = data => ({
  type: INVOICE_UPDATE_SUCCESS,
  payload: {data}
});

export const invoiceUpdateError = error => ({
  type: INVOICE_UPDATE_ERROR,
  payload: error,
});
